<template>
  <div class="app-body" ref="body">
    <app-header>
      <div slot="left" class="logo" @click="goBack">
        <img :src="sitelogo" style="display:block; height:46px;">
      </div>
      <div slot="title">意见反馈</div>
    </app-header>
    <div class="form">
      <el-form :model="editData" :rules="rules" size="small" label-position="top" ref="form">
        <template v-for="item in list">
          <el-form-item :key="item.id" :label="item.name" :prop="item.id +'.value'" :rules="rules[item.id]">
            <div v-if="!item.isgroup">
              <el-input v-if="item.type == 1 || item.type == 2" :type="item.type == 2 ? 'textarea' : ''" v-model="editData[item.id].value" :autosize="item.type == 2 ? {minRows:2} : false"></el-input>
              <el-select v-if="item.type == 3" v-model="editData[item.id].value">
                <template v-for="(o, oi) in item.options">
                  <el-option :key="oi" :label="o" :value="o"></el-option>
                </template>
              </el-select>
              <el-radio-group v-if="item.type == 4" v-model="editData[item.id].value">
                <template v-for="(o, oi) in item.options">
                  <el-radio :key="oi" :label="o">{{ o }}</el-radio>
                </template>
              </el-radio-group>
            </div>
            <div v-if="item.isgroup" slot="label" class="label-group">{{ item.name }}</div>
          </el-form-item>
        </template>
        <div class="btns">
          <el-button type="primary" @click="submitForm('form')">提交反馈意见</el-button>
          <el-button type="info" @click="resetForm('form')">重置</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import tools from '@/utils/tools';
import AppHeader from '../app-header.vue';
import 'element-ui/lib/theme-chalk/index.css';
import { Form, FormItem, Input, Select, RadioGroup, Radio, Button } from 'element-ui';
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Select);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Button);
export default {
  components: {
    AppHeader
  },
  mixins: [tools],
  data() {
    return {
      isLoading: false,
      list: [],
      editData: {},
    }
  },
  computed: {
    rules() {
      var _rule = {};
      this.list.forEach((n, i) => {
        _rule[n.id] = {required: n.required, message:'请填写内容'};
        if (n.rule) {
          if (n.rule == 'mail') {
            _rule[n.id].type = 'email';
            _rule[n.id].message = '请填写正确的邮箱地址';
          } else if (n.rule == 'mobile') {
            _rule[n.id].pattern = /^1[3456789]\d{9}$/;
            _rule[n.id].message = '请填写正确的手机号码';
          } else if (n.rule == 'idcard') {
            _rule[n.id].pattern = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/;
            _rule[n.id].message = '请填写正确的身份证号码';
          }
        }
      });
      return _rule;
    }
  },
  watch: {
  },
  created () {
    // resize
    let resizeId;
    window.addEventListener('resize', () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.getImgW, 300);
    });
  },
  mounted () {
  },
  activated() {
    if (!this.list || !this.list.length) {
      this.loadData();
    }
  },
  methods: {
    loadData(callback) {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.doGet({
        url: 'vue/home/question',
        okcb: (json) => {
          this.list = json;
          this.list.map((d, index) => {
            if (d.type == 3 || d.type == 4) {
              this.$set(d, 'options', d.selects ? JSON.parse(d.selects) : []);
            }
            let _data = {name:d.name, value:null, seq:index};
            if (d.rule) {
              _data.rule = n.rule;
            }
            this.$set(this.editData, d.id, _data);
          });
          if (callback) {
            callback(json);
          }
        },
        cb: () => {
          this.$nextTick(() => this.isLoading = false);
        },
        errcb: () => {
          this.error = true;
        }
      });
    },
    goBack() {
      this.$router.push('/');
    },
    submitForm(form) {
      var _this = this;
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.Toast.loading({
            message: '加载中...',
            forbidClick: true
          });
          var others = [];
          Object.keys(this.editData).forEach((k) => {
            let v = this.editData[k];
            let _other = {id: k, name: v.name, seq: v.seq, value: v.value};
            if (v.rule) {
              _other.rule = v.rule;
            }
            if (v.isgroup) {
              _other.isgroup = true;
            }
            others.push(_other);
          });
          this.doPost({
            url: 'vue/home/answer',
            data: {id: this.editData.id, content: JSON.stringify(others)},
            okcb: (json) => {
              this.editData.id = json.id;
              setTimeout(() => {
                this.Toast.success('提交成功，谢谢您的反馈！');
              }, 100);
              setTimeout(() => {
                this.$router.push('/');
              }, 3000);
            },
            cb: () => {
              this.Toast.clear();
            }
          });
        }
      });
    },
    resetForm(form) {
      this.editData.id = '';
      this.loadData(() => {
        setTimeout(() => {
          this.$refs[form].resetFields();
          this.$refs[form].clearValidate();
        }, 200);
      });
    }
  }
}
</script>

<style lang="less" scoped>
.app-body{margin-top:0; margin-bottom:50px; background-color:#fff;}
.app-header {
  .logo {
    line-height:46px;
  }
}
.form {
  margin-top:4rem;
  padding:1rem;
  /deep/ .el-form-item--small .el-form-item__label {
    padding-bottom:0;
    font-weight:bold;
    color:#777;
  }
  /deep/ .el-radio {
    margin-right:1rem;
  }
  /deep/ .el-radio__label {
    padding-left:3px;
  }
  .label-group {
    padding:0 1rem;
    background-color:#eee;
  }
  .btns {
    text-align:center;
  }
}
</style>